import { createContext } from 'react';
import { RdsStatusContextType } from '../types';

export const RdsStatusContext = createContext({} as RdsStatusContextType);
